import { ClassAttributes, createElement } from 'react';

import Component from '../component/compound/NonFatalErrorSnackbars';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as StateConsumer } from '../context/state';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const NonFatalErrorSnackbars = ({ className }: Props) => (
  <DependencyConsumer>
    {(dependency) => (
      <StateConsumer>
        {(state) => (
          <Component
            errors={state.nonFatalErrors.toArray()}
            onRequestClose={(_: any, err: Error) => dependency.errorPresenter.removeNonFatal(err)}
            className={className}
          />
        )}
      </StateConsumer>
    )}
  </DependencyConsumer>
);

export default NonFatalErrorSnackbars;
